import { getAvailabilityMapDataSelector } from 'selectors/availabilitySearchSelectors';
import { useSelector } from 'react-redux';

export const useMapData = () => useSelector(getAvailabilityMapDataSelector);
